import { PayloadAction } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

export class ActionCache<K, T> {
  private promiseCache: Map<K, Promise<PayloadAction<T>>>;

  /**
   * Cache responses from Thunk Actions.  This is an in memory cache which will live until the SPA is exited or the page is refreshed.
   * @typeParam K the type of the data used as the key
   * @typeParam T the type returned from the api call
   */
  constructor() {
    this.promiseCache = new Map<K, Promise<PayloadAction<T>>>();
  }

  async Load(id: K, dispatch: Function, thunkAction: Function) {
    if (!this.promiseCache.has(id)) {
      this.promiseCache.set(id, dispatch(thunkAction(id)));
    }

    const response = await this.promiseCache.get(id);
    //clone the response to prevent the UI from modifying cached value
    return cloneDeep(response);
  }
}
